import { ContactMeet } from './pages/contact-meet';
import { Contact } from "./pages";

export const ContactRoute = {
  component: Contact,
  url: '/contact',
  exact: false,
};
// @TODO refactor to routes /contact/participant/:id and /contact/corporation/:id

export const ContactMeetRoute = {
  component: ContactMeet,
  url: '/contact-meet',
  exact: false,
};
